import { DownloadOutlined, FileDoneOutlined } from '@ant-design/icons';
import LoginLink from 'components/Common/LoginLink';
import React, { useState, useEffect } from 'react';
import { ExamInfoRoute, PassedUrl } from 'services/routes';
import { ellipsisText, faNumber, fileSize } from 'utils/common.util';
import fa from 'locales/fa.json';
import { message, Spin, Tooltip } from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import request from 'services/request';
import { UPDATE_USER } from 'store/account/account.constants';
import { useRouter } from 'next/router';
import CreateQuestionModal from 'components/Common/CreateQuestionModal';
import { getTermAction } from 'store/course/course.action';

type ActionType = {
  data: any; // eslint-disable-line
  registered: boolean;
  passed: boolean;
  term?: boolean;
  film?: string;
  audio?: string;
};

const LessonActions: React.FC<ActionType> = (props) => {
  const { data, registered, film, audio, passed, term } = props;
  const dispatch = useDispatch();
  const router = useRouter();
  const { termId } = router.query;
  const [seeStatus, setSeeStatus] = useState(false);
  const [seeLoading, setSeeLoading] = useState(false);
  const [showCreateQuestionModal, setShowCreateQuestionModal] = useState(false);
  const { courseId, lessonId } = router.query;
  const user = useSelector((state) => state.account.user);

  useEffect(() => {
    !data?.can_start_exam && passed ? setSeeStatus(true) : setSeeStatus(false);
  }, [data]);

  const handleSeen = async (): Promise<void> => {
    setSeeLoading(true);
    const res: any = await request.post(PassedUrl(courseId, lessonId)); // eslint-disable-line
    setSeeLoading(false);
    res.ok && (setSeeStatus(true), message.success(res.data.message));
    res.ok && term
      ? dispatch(getTermAction(termId))
      : dispatch({
          type: UPDATE_USER,
          filed: 'passed_lessons',
          lessonId,
          courseId,
        });
  };

  return (
    <div className="absolute p-[20px] flex-col md:flex-wrap flex text-[15px] bg-white bottom-[480px] md:bottom-[490px] rounded-[8px]  w-full xl:bottom-0 h-[170px] md:h-[150px]">
      {!data || !data?.exam_id ? null : data?.exam?.passed ? (
        <div className="mb-[14px] rounded-[4px] items-center flex text-green-5">
          {`شما با نمره ${faNumber(data?.exam?.grade)} قبول شدید.`}
        </div>
      ) : (
        registered &&
        !!data.can_start_exam && (
          <LoginLink href={ExamInfoRoute(data.exam_id)}>
            <div
              onClick={(): void =>
                termId && localStorage.setItem('termId', JSON.stringify(Number(termId)))
              }
              className="mb-5 rounded-[4px] items-center flex cursor-pointer text-gray-3 hover:text-black duration-300"
            >
              <FileDoneOutlined className="ml-[8px] text-[25px]" /> {fa.course.exam}
            </div>
          </LoginLink>
        )
      )}

      {film && (
        <a
          href={film}
          className="mb-5 rounded-[4px] cursor-pointer text-gray-3 hover:text-black duration-300"
          target="_blank"
          rel="noreferrer"
        >
          <DownloadOutlined className="ml-[8px] text-[20px]" />
          {fa.course.videoDownload}
          {/* {fileSize(lesson?.files[0].size)}) */}
        </a>
      )}
      {audio && (
        <a
          href={audio}
          className="mb-5 rounded-[4px] cursor-pointer text-gray-3 hover:text-black duration-300"
          target="_blank"
          rel="noreferrer"
        >
          <DownloadOutlined className="ml-[8px] text-[20px]" />
          {fa.course.voiceDownload}
          {/* {fileSize(lesson?.files[0].size)}) */}
        </a>
      )}

      {data?.attaches.length < 3 &&
        data?.attaches.map((item) => (
          <a
            key={item.link}
            href={item.link}
            className="mb-5 rounded-[4px] cursor-pointer text-gray-3 hover:text-black duration-300"
            target="_blank"
            rel="noreferrer"
          >
            <DownloadOutlined className="ml-[8px] text-[20px]" />
            <Tooltip title={item.name}>
              {ellipsisText(item.name, 14)} ({fileSize(item.size)})
            </Tooltip>
          </a>
        ))}

      {data && registered && !data?.can_start_exam && (
        <Checkbox
          checked={seeStatus}
          disabled={seeStatus}
          className="text-gray-3 hover:text-black duration-300"
          onClick={handleSeen}
        >
          <div className="mb-5 text-gray-3 hover:text-black">
            {fa.course.isSeen}
            <Spin spinning={seeLoading} />
          </div>
        </Checkbox>
      )}

      {data?.exam_id && data.has_create_exam && user?.can_create_exam_question && (
        <div
          className="cursor-pointer text-gray-3 hover:text-black duration-300"
          onClick={(): void => setShowCreateQuestionModal(true)}
        >
          {fa.course.createQuestion}
        </div>
      )}

      <CreateQuestionModal
        id={data?.exam_id}
        isOpen={showCreateQuestionModal}
        setOpen={setShowCreateQuestionModal}
      />
    </div>
  );
};

export default LessonActions;
